// CustomCheckbox.jsx
import React from "react";
import "../styles/CustomCheckbox.css"; // CSS 파일

const CustomCheckbox = ({ checked, onChange, disabled }) => {
  return (
    <label className="checkbox-wrapper">
      <input
        type="checkbox"
        className="hidden-checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className="custom-checkbox" />
    </label>
  );
};

export default CustomCheckbox;
